import { useNProgress } from "@tanem/react-nprogress";
import { UiContainer } from "./UiContainer";
import { UiSpinner } from "./UiSpinner";
import { UiBar } from "./UiBar";

export const UiProgress = ({ isAnimating }) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating,
  });

  return (
    <UiContainer animationDuration={animationDuration} isFinished={isFinished}>
      <UiBar animationDuration={animationDuration} progress={progress} />
      <UiSpinner />
      {/*
              This example doesn't use a spinner component so the UI stays
              tidy. You're free to render whatever is appropriate for your
              use-case.
              */}
    </UiContainer>
  );
};
